module.exports = __webpack_public_path__ + "static/media/logo-small.2cdf70cf.svg";